import { gql } from "@apollo/client"

export const MUTATION = gql`
  mutation UpdateOfferRequestPurchase($input: OfferRequestPurchaseInput!) {
    updateOfferRequestPurchase(input: $input)
  }
`
